import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { IDmNguonBietToiType } from '../../../models/response/category/IDmNguonBietToiType';
import { eNguonBietToiTypeActionTypeIds, INguonBietToiTypeActionTypes } from '../../action-types/crm-category/IDmNguonBietToiTypeActionTypes';
import { actions } from '../../actions/actionsWrapper';


export function* nguonBietToiTypeSaga(): any {
    yield takeLatest(eNguonBietToiTypeActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eNguonBietToiTypeActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eNguonBietToiTypeActionTypeIds.DELETE_START, deleteWorker)
}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(apiWrapper.crmCategoryWrapper.nguonBietToiType.select_all)
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.nguonBietToiType.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.crmCategoryWrapper.nguonBietToiType.LOAD_ERROR(res.message ?? "Error"))
    }
}
function* saveWorker(action: INguonBietToiTypeActionTypes): any {
    const payload: IDmNguonBietToiType = action.payload as IDmNguonBietToiType;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.crmCategoryWrapper.nguonBietToiType.update, payload)
    } else {
        res = yield call(apiWrapper.crmCategoryWrapper.nguonBietToiType.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.nguonBietToiType.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.crmCategoryWrapper.nguonBietToiType.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: INguonBietToiTypeActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.crmCategoryWrapper.nguonBietToiType.delete, payload)
    if (res.is_success) {
        yield put(actions.crmCategoryWrapper.nguonBietToiType.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.crmCategoryWrapper.nguonBietToiType.DELETE_ERROR(res.message ?? "Error"))
    }
}
